import axios, { AxiosRequestConfig, AxiosResponse, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { store } from '../redux/store';
import { showLoader, hideLoader } from '../redux/slice/loaderSlice';
import { logout } from '../redux/slice/userSlice';

// Define the base URL for your API client
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL + 'api/',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 100000, // good practice to avoid hanging requests
  withCredentials: true,
});


// Add token before every request
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {  // Change the type here
    store.dispatch(showLoader());
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // config.headers.Authorization = `Bearer ${process.env.REACT_APP_ORGANIZATION_ID}`;

    }
    return config;
  },
  (error: AxiosError) => {
    store.dispatch(hideLoader());
    return Promise.reject(error);
  }
);

// Optional: Handle common response errors globally
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    store.dispatch(hideLoader());
    return response;
  },
  (error: AxiosError) => {
    store.dispatch(hideLoader());

    // If status is 401 (Unauthorized), logout the user and redirect to login page
    if (error.response?.status === 401) {
      store.dispatch(logout());
      const token = localStorage.getItem('authToken');
      console.warn('Unauthorized. Logging out...',token);

      // Optional: Redirect to login page
      if (token) {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

// Creating the `apiRequest` method using this configured client.
interface ApiRequestProps {
  method: string;
  url: string;
  data?: any;
  params?: any;
  headers?: Record<string, string>;
  config?: AxiosRequestConfig;
}

export const apiRequest = async ({
  method = 'get',
  url,
  data = null,
  params = null,
  headers = {},
  config = {},
}: ApiRequestProps): Promise<any> => {
  try {
    const response = await apiClient({
      method,
      url,
      data,
      params,
      headers,
      ...config, 
    });

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      const errorMessage = response.data?.message || 'An error occurred!';
      throw new Error(errorMessage);
    }
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'An unexpected error occurred!';
    console.error('Error Response:', error.response);
    throw new Error(errorMessage);
  }
};

export default apiClient;
